<div class="modal-header" style="padding-bottom: 0%;">
	<h3 class="modal-title" id="modal-title-id" style="padding-bottom: 0%;">{{LOCALIZATION.alerts}}</h3>
</div>
<div class="modal-body" >
	<div class="row">
		<div class="col-sm-12">
			<button class="btn btn-default" type="button" style="margin: 0 2px 0 0;"
			    [ngStyle]="{'background-color': alertsMode === 'success' ? '#dff0d8' : 'white'}" 
			    (click)="toggleMode('success')">{{LOCALIZATION.alertSuccess}}</button>
			<button class="btn btn-default" type="button" style="margin: 0 2px 0 0;"
				[ngStyle]="{'background-color': alertsMode === 'info' ? '#d9edf7' : 'white'}"
			    (click)="toggleMode('info')">{{LOCALIZATION.alertInfo}}</button>
			<button class="btn btn-default" type="button" style="margin: 0 2px 0 0;"
				[ngStyle]="{'background-color': alertsMode === 'danger' ? '#f2dede' : 'white'}"
			 	(click)="toggleMode('danger')">{{LOCALIZATION.alertError}}</button>
		 </div>
	</div>
	<table class="table table-condensed table-no-border">
		<tbody>
			<tr>
				<td>{{LOCALIZATION.date}}</td>
				<td>{{LOCALIZATION.alertsTitle}}</td>
				<td>{{LOCALIZATION.alertsMessage}}</td>
			</tr>
			<tr *ngFor="let alert of alertsView; let i = index" class="alert alert-{{alert.status}}">
				<td>{{alert.date}}</td>
				<td>{{alert.title}}</td>
				<td>{{alert.message}}</td>
				<td>
					<i class="nav-icon fa fa-trash " (click)="closeAlert(i)"></i>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
